import { SnIntegrationLayer } from '../integration-layer';
import { SnFirstTwoLayer } from './first-two';
import { SnRedbookLayer } from './redbook';

export type SnIntegrationLayerType = SnIntegrationLayer | SnFirstTwoLayer | SnRedbookLayer;
